import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Form, Input, Row, Col, Button, Select, Table } from 'antd';
import util from '../../../util/index';

const {
  getParams,
} = util;
const FormItem = Form.Item;
const createForm = Form.create;
const Option = Select.Option;

@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    formPrefixCls: 'sys-basic',
    prefixCls: 'sys-user',
  }
  componentDidMount() {
    this.reset();
  }
  reset = () => {
    const { form, sysStore: { init, getSysPersons } } = this.props;
    form.resetFields();
    init();
    getSysPersons();
  }
  onSubmit = () => {
    const { sysStore: { init, getSysPersons }, form } = this.props;
    init(false);
    const params = getParams(form.getFieldsValue());
    if (params.role === 'all') delete params.role;
    getSysPersons(params);
  }
  getColumns = () => {
    const { sysStore: { routing } } = this.props;
    return [
      { title: '用户名', dataIndex: 'm_name', key: 'm_name', },
      { title: '公司', dataIndex: 'm_Comname', key: 'm_Comname', },
      { title: '分部', dataIndex: 'm_branch', key: 'm_branch', },
      { title: '部门', dataIndex: 'm_department', key: 'm_department', },
      { title: '岗位', dataIndex: 'm_position', key: 'm_position', },
      { title: '角色', dataIndex: 'm_role', key: 'm_role', },
      { title: '登录账号', dataIndex: 'm_user', key: 'm_user', },
      {
        title: '操作', dataIndex: 'm_id', key: 'm_id', render: (text, record) => {
          const me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
          const disabled = !(me.com === 'weaver' && me.role === 'admin');
          return (<div onClick={() => {
            !disabled && routing.push({
              pathname: '/sys/user/changeRole',
              query: {
                mid: record.m_id,
              }
            })
          }} style={{ color: disabled ? '#999' : '#1890ff', cursor: 'pointer' }}>修改</div> );
        },
      },
    ];
  }
  onTableChange = (current, pageSize) => {
    const { sysStore: { getSysPersons, setMobxState }, form } = this.props;
    setMobxState({ current, pageSize });
    const params = getParams(form.getFieldsValue());
    getSysPersons({ ...params, current, pageSize });
  }
  render() {
    const { prefixCls, formPrefixCls, form, sysStore: { userList, userCount, loading, pageSize, current } } = this.props;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { getFieldProps } = form;
    return (
      <div className={`${formPrefixCls} ${prefixCls}`}>
        <div className={`${prefixCls}-header`}>
          <Form>
            <Row>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="用户名：" {...formItemLayout}>
                  <Input placeholder="请输入用户名" {...getFieldProps('name')}/>
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="公司：" {...formItemLayout}>
                  <Input placeholder="请输入公司" {...getFieldProps('comname')} />
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row ${prefixCls}-row-btn`}>
                <Button type="primary" onClick={this.onSubmit}>搜索</Button>
                <Button onClick={this.reset}>重置</Button>
              </Col>
            </Row>
            <Row>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="分部：" {...formItemLayout}>
                  <Input placeholder="请输入分部" {...getFieldProps('branch')} />
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="部门：" {...formItemLayout}>
                  <Input placeholder="请输入部门" {...getFieldProps('dep')} />
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="角色：" {...formItemLayout}>
                  <Select {...getFieldProps('role', {
                    initialValue: 'all'
                  })}> 
                    <Option value='all'>全部</Option>
                    <Option value="40">会员</Option>
                    <Option value="45">开发者</Option>
                    <Option value="70">公司管理员</Option>
                    <Option value="80">管理员</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>
        <Table
          rowKey="m_id"
          loading={loading}
          dataSource={toJS(userList)}
          columns={this.getColumns()}
          pagination={{
            total: userCount,
            pageSize: pageSize,
            current: current,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: total => (<span>共{total}条</span>),
            onChange: this.onTableChange,
            onShowSizeChange: (page, size) => this.onTableChange(1, size),
          }} />
      </div>
    )
  }
}

Main = createForm()(Main);
export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/user/UserList.js